import IngredientForm from './IngredientForm'
export {IngredientForm}
export default IngredientForm
